import { Component, EventEmitter, Input, Output } from '@angular/core';
export type AssessmentSubmitConfirmTheme = 'sa' | 'sb';
export type AssessmentDialogMode = 'confirm' | 'success';
@Component({
  selector: 'app-assessment-submit-confirm',
  templateUrl: './assessment-submit-confirm.component.html',
  styleUrls: ['./assessment-submit-confirm.component.scss']
})
export class AssessmentSubmitConfirmComponent {
 @Input() open = false;
  @Input() mode: AssessmentDialogMode = 'confirm';
  @Input() theme: AssessmentSubmitConfirmTheme = 'sb';
  @Input() successTitle = 'Congratulation';
  @Input() successMessage = '';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  onBackdropClick(): void {
    if (this.mode === 'success') {
      this.dismissed.emit();
      return;
    }
    this.cancelled.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  onConfirm(): void {
    this.confirmed.emit();
  }

  onDismiss(): void {
    this.dismissed.emit();
  }
}
